"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "taglio-di-po": {
    "cf45f028": [{
      "hkey": "df9e17e9",
      "slug": "taglio-di-po",
      "name": "Taglio di Po",
      "primary": true,
      "skipSearch": false
    }],
    "bibia": [{
      "hkey": "df9e17e9",
      "slug": "taglio-di-po",
      "name": "Taglio di Po",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1e9ea709": [{
      "hkey": "df9e17e9",
      "slug": "taglio-di-po",
      "name": "Taglio di Po",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-mosca": [{
      "hkey": "df9e17e9",
      "slug": "taglio-di-po",
      "name": "Taglio di Po",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7cf6cc02": [{
      "hkey": "df9e17e9",
      "slug": "taglio-di-po",
      "name": "Taglio di Po",
      "primary": true,
      "skipSearch": false
    }],
    "ca-lattis": [{
      "hkey": "df9e17e9",
      "slug": "taglio-di-po",
      "name": "Taglio di Po",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8fc479d4": [{
      "hkey": "df9e17e9",
      "slug": "taglio-di-po",
      "name": "Taglio di Po",
      "primary": true,
      "skipSearch": false
    }],
    "ca-papadopoli": [{
      "hkey": "df9e17e9",
      "slug": "taglio-di-po",
      "name": "Taglio di Po",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "af04146a": [{
      "hkey": "df9e17e9",
      "slug": "taglio-di-po",
      "name": "Taglio di Po",
      "primary": true,
      "skipSearch": false
    }],
    "gorino-sullam": [{
      "hkey": "df9e17e9",
      "slug": "taglio-di-po",
      "name": "Taglio di Po",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "38b22942": [{
      "hkey": "df9e17e9",
      "slug": "taglio-di-po",
      "name": "Taglio di Po",
      "primary": true,
      "skipSearch": false
    }],
    "zona-marina-ca-vendramin": [{
      "hkey": "df9e17e9",
      "slug": "taglio-di-po",
      "name": "Taglio di Po",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;